import React, { useState } from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import Img from 'gatsby-image';
import parse from 'html-react-parser';
import GenerateLink from "../../common/site/generate-link"
import VirtualTourPlay from "../../Play/CustomVideoFullImageClick"

import PlayVideo from '../../../components/Play/PlayVideo';

import "./About.scss"

import { inViewOptions, containerVariants, contentItem, fadeInFromTop, titleVariants, contentVariants } from '../../utils/animation';

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const About = (props) => {
    const [isPlay, setPlay] = useState(false);
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    className="about-section components--Home--About--About"
                    ref={ref}
                    initial="hidden"
                    animate={"visible"}
                    variants={containerVariants}

                >
                    <Container>
                        {props.Intro_Image ?
                            <Row>
                                {props.Intro_Image &&
                                    <Col md="12" lg="6" xl="7">
                                        <motion.div variants={titleVariants} className={`image-video ${props.Intro_Video_URL ? 'img-cursor' : ''}`}>
                                            {props.Intro_Video_URL ?
                                                <VirtualTourPlay url={props.Intro_Video_URL}>
                                                    <Img fluid={props.Intro_Image.url_sharp.childImageSharp.fluid} alt={props.Intro_Image.alternativeText} />
                                                </VirtualTourPlay>
                                                :
                                                <Img fluid={props.Intro_Image.url_sharp.childImageSharp.fluid} alt={props.Intro_Image.alternativeText} />
                                            }
                                        </motion.div>
                                    </Col>
                                }
                                <Col md="12" lg="6" xl="5">
                                    <motion.div variants={contentVariants} className="about-content">
                                        {props.Intro_Title &&
                                            <span className="sub-title">{props.Intro_Title}</span>
                                        }
                                        {props.Intro_Content &&
                                            <>
                                                {parse(props.Intro_Content)}
                                            </>
                                        }

                                        {props.Intro_CTA_Label && props.Intro_CTA_Link &&
                                            <GenerateLink link={props.Intro_CTA_Link} class="btn">{props.Intro_CTA_Label} <i className="icon-arrow"></i>
                                            </GenerateLink>
                                        }

                                    </motion.div>
                                </Col>
                            </Row>
                            :
                            <Row>
                                <Col md="12">
                                    <motion.div variants={titleVariants} className="about-block-title">
                                        {props.Intro_Title &&
                                            <span className="sub-title">{props.Intro_Title}</span>
                                        }

                                        {props.Intro_Heading &&
                                            <>
                                                {parse(props.Intro_Heading)}
                                            </>
                                        }
                                    </motion.div>
                                </Col>
                                <Col md="12" className="d-lg-flex justify-content-end">
                                    <motion.div variants={contentVariants} className="about-block">
                                        {props.Intro_Content &&
                                            <>
                                                {parse(props.Intro_Content)}
                                            </>
                                        }

                                        {props.Intro_CTA_Label && props.Intro_CTA_Link &&
                                            <GenerateLink link={props.Intro_CTA_Link} class="link-text"><span>{props.Intro_CTA_Label}</span> <i className="icon-arrow"></i></GenerateLink>
                                        }
                                    </motion.div>
                                </Col>
                            </Row>
                        }
                    </Container>
                </motion.section>
            )}
        </InView>

    )
}
export default About
